module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "Style": "margin-top:50px"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "16px",
      "text-align": "center",
      "line-height": "35px",
      "margin-left": "1%"
    }
  }, [_vm._v("完成状态:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "float": "left",
      "margin-left": "1%"
    },
    attrs: {
      "size": _vm.selectSize,
      "placeholder": "点击以筛选"
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "2%",
      "text-align": "center",
      "line-height": "35px",
      "font-size": "16px"
    }
  }, [_vm._v("标题/内容:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px",
      "float": "left",
      "margin-left": "1%"
    },
    attrs: {
      "placeholder": "输入标题或内容用以检索",
      "prefix-icon": "el-icon-search",
      "autofocus": "first_input",
      "clearable": ""
    },
    model: {
      value: (_vm.findStr),
      callback: function($$v) {
        _vm.findStr = $$v
      },
      expression: "findStr"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-search",
    staticStyle: {
      "float": "left",
      "margin-left": "2%"
    },
    attrs: {
      "type": "primary",
      "icon": "icon-search"
    },
    on: {
      "click": _vm.getdata
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {}), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "infinite-list",
    staticStyle: {
      "float": "center",
      "height": "500px",
      "width": "100%",
      "overflow": "auto"
    },
    attrs: {
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-distance": "5",
      "infinite-scroll-delay": "2000"
    }
  }, _vm._l((_vm.countData), function(item) {
    return _c('div', {
      staticClass: "infinite-list-item"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('el-card', {
      staticClass: "box-card"
    }, [(item.state == 3) ? _c('div', {
      staticClass: "notice-card-num notice-card-num-no",
      on: {
        "click": function($event) {
          _vm.toUpdateNoticeState(item.num, item.state, item.counts)
        }
      }
    }, [_vm._v("未读")]) : _vm._e(), _vm._v(" "), (item.state == 2) ? _c('div', {
      staticClass: "notice-card-num notice-card-num-un",
      on: {
        "click": function($event) {
          _vm.checkData(item.num, item.counts)
        }
      }
    }, [_vm._v("处理")]) : _vm._e(), _vm._v(" "), (item.state < 2) ? _c('div', {
      staticClass: "notice-card-num notice-card-num-finish",
      on: {
        "click": function($event) {
          _vm.checkData(item.num, item.counts)
        }
      }
    }, [_vm._v("完成")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('div', {
      staticClass: "notice-card-titles"
    }, [_vm._v(_vm._s(item.titles))]), _vm._v(" "), _c('div', {
      staticClass: "notice-card-time"
    }, [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "notice-card-body"
    }, [_vm._v(_vm._s(item.bodys))])])])], 1)])
  })), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "处理记录",
      "visible": _vm.dialogFormVisible,
      "modal-append-to-body": false,
      "show-close": false,
      "width": "200px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.form2.titles))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "110px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.form2.createTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "此处显示报警内容",
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.bodys),
      callback: function($$v) {
        _vm.$set(_vm.form2, "bodys", $$v)
      },
      expression: "form2.bodys"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理结果",
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.form2.state == 2) ? _c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "请填入您的处理结果",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form2, "remarks", $$v)
      },
      expression: "form2.remarks"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form2.state != 2) ? _c('div', [_vm._v(_vm._s(_vm.form2.remarks))]) : _vm._e()], 1), _vm._v(" "), (_vm.form2.state == 1) ? _c('el-form-item', {
    attrs: {
      "label": "处理时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.form2.finishTime))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有无通知用户",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.form2.notifyState ? '已通知' : '暂无',
      "placement": "top"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form2.notifyState),
      callback: function($$v) {
        _vm.$set(_vm.form2, "notifyState", $$v)
      },
      expression: "form2.notifyState"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.toUpdateNotice(_vm.form2.counts)
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-366400f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Notice/NoticeView.vue
// module id = 1735
// module chunks = 1